import { LookupCodes } from 'src/constants/lookup.constants';
import { GroupedImageToolOptions } from '../base-toolbar/toolbar-options/tool-options-renderer/grouped-image-tool/GroupedImageToolOptions';
import { ColorToolOptions } from '../base-toolbar/toolbar-options/tool-options-renderer/color-tool/ColorToolOptions';
import { SingleColumnToolOptions } from '../base-toolbar/toolbar-options/tool-options-renderer/single-column-tool/SingleColumnToolOptions';
import { AvailableToolsMap } from '../base-toolbar/BaseToolbar.types';
import { TextToolOptions } from '../base-toolbar/toolbar-options/tool-options-renderer/text-tool/TextToolOptions';
import { SingleRowToolOptions } from '../base-toolbar/toolbar-options/tool-options-renderer/single-row-tool-v3/SingleRowToolOptions';
// import { SingleBigRowToolOptions } from '../base-toolbar/toolbar-options/tool-options-renderer/single-big-row-tool-v3/SingleBigRowToolOptions';

// The Map of all available tools for the group lookup toolbar
// deprecated
export const AVAILABLE_GROUP_TOOLS: AvailableToolsMap = {
  [LookupCodes.FORMAT]: {
    ToolOptionsRenderer: GroupedImageToolOptions,
  },
  [LookupCodes.PAPER]: {
    ToolOptionsRenderer: SingleColumnToolOptions,
  },
  [LookupCodes.PASSEPARTOUT]: {
    ToolOptionsRenderer: ColorToolOptions,
  },
  [LookupCodes.CORRECTION]: {
    ToolOptionsRenderer: SingleColumnToolOptions,
  },
  [LookupCodes.PAPER_COLOR]: {
    ToolOptionsRenderer: ColorToolOptions,
  },
  [LookupCodes.TEXT]: {
    ToolOptionsRenderer: TextToolOptions,
  },
  [LookupCodes.PRINT_TYPE]: {
    // EUS-869: Remove this tool from the lookup bar, maybe later will be added back
    // ToolOptionsRenderer: SingleColumnToolOptions,
  },
};

export const AVAILABLE_GROUP_TOOLS_V3: AvailableToolsMap = {
  [LookupCodes.FORMAT]: {
    ToolOptionsRenderer: SingleRowToolOptions,
  },
  [LookupCodes.PAPER]: {
    ToolOptionsRenderer: SingleRowToolOptions,
  },
  [LookupCodes.PASSEPARTOUT]: {
    ToolOptionsRenderer: ColorToolOptions,
  },
  [LookupCodes.CORRECTION]: {
    ToolOptionsRenderer: SingleRowToolOptions,
  },
  [LookupCodes.PAPER_COLOR]: {
    ToolOptionsRenderer: ColorToolOptions,
  },
  [LookupCodes.TEXT]: {
    ToolOptionsRenderer: TextToolOptions,
  },
  [LookupCodes.PRINT_TYPE]: {
    // EUS-869: Remove this tool from the lookup bar, maybe later will be added back
    // ToolOptionsRenderer: SingleBigRowToolOptions,
  },
};

export const TOOLS_WITH_PRICE = [LookupCodes.FORMAT, LookupCodes.CORRECTION];
